/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */

/**
 * Modules in this bundle
 * @license
 *
 * scroll-hint:
 *   license: MIT (http://opensource.org/licenses/MIT)
 *   author: steelydylan
 *   version: 1.2.8
 *
 * es6-object-assign:
 *   license: MIT (http://opensource.org/licenses/MIT)
 *   author: Rubén Norte <rubennorte@gmail.com>
 *   homepage: https://github.com/rubennorte/es6-object-assign
 *   version: 1.1.0
 *
 * This header is generated by licensify (https://github.com/twada/licensify)
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.ScrollHint=f()}})(function(){var define,module,exports;return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s}({1:[function(require,module,exports){"use strict";function assign(target,firstSource){if(target===undefined||target===null){throw new TypeError("Cannot convert first argument to object")}var to=Object(target);for(var i=1;i<arguments.length;i++){var nextSource=arguments[i];if(nextSource===undefined||nextSource===null){continue}var keysArray=Object.keys(Object(nextSource));for(var nextIndex=0,len=keysArray.length;nextIndex<len;nextIndex++){var nextKey=keysArray[nextIndex];var desc=Object.getOwnPropertyDescriptor(nextSource,nextKey);if(desc!==undefined&&desc.enumerable){to[nextKey]=nextSource[nextKey]}}}return to}function polyfill(){if(!Object.assign){Object.defineProperty(Object,"assign",{enumerable:false,configurable:true,writable:true,value:assign})}}module.exports={assign:assign,polyfill:polyfill}},{}],2:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _es6ObjectAssign=require("es6-object-assign");var _util=require("./util");function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}var defaults={suggestClass:"is-active",scrollableClass:"is-scrollable",scrollableRightClass:"is-right-scrollable",scrollableLeftClass:"is-left-scrollable",scrollHintClass:"scroll-hint",scrollHintShadowWrapClass:"scroll-hint-shadow-wrap",scrollHintIconClass:"scroll-hint-icon",scrollHintIconAppendClass:"",scrollHintIconWrapClass:"scroll-hint-icon-wrap",scrollHintText:"scroll-hint-text",scrollHintBorderWidth:10,remainingTime:-1,enableOverflowScrolling:true,applyToParents:false,suggestiveShadow:false,offset:0,i18n:{scrollable:"scrollable"}};var ScrollHint=function(){function ScrollHint(ele,option){var _this=this;_classCallCheck(this,ScrollHint);this.opt=(0,_es6ObjectAssign.assign)({},defaults,option);this.items=[];var elements=void 0;if(ele instanceof HTMLElement){elements=[ele]}else if(typeof ele==="string"){elements=document.querySelectorAll(ele)}else{elements=ele}var applyToParents=this.opt.applyToParents;[].forEach.call(elements,function(element){if(applyToParents){element=element.parentElement}element.style.position="relative";element.style.overflow="auto";if(_this.opt.enableOverflowScrolling){if("overflowScrolling"in element.style){element.style.overflowScrolling="touch"}else if("webkitOverflowScrolling"in element.style){element.style.webkitOverflowScrolling="touch"}}var item={element:element,scrolledIn:false,interacted:false};document.addEventListener("scroll",function(e){if(e.target===element){item.interacted=true;_this.updateItem(item)}},true);(0,_util.addClass)(element,_this.opt.scrollHintClass);_this.items.push(item);(0,_util.append)(element,'<div class="'+_this.opt.scrollHintIconWrapClass+'" data-target="scrollable-icon">\n        <span class="'+_this.opt.scrollHintIconClass+(_this.opt.scrollHintIconAppendClass?" "+_this.opt.scrollHintIconAppendClass:"")+'">\n          <div class="'+_this.opt.scrollHintText+'">'+_this.opt.i18n.scrollable+"</div>\n        </span>\n      </div>");if(_this.opt.suggestiveShadow){var wrapper=document.createElement("div");wrapper.classList.add(_this.opt.scrollHintShadowWrapClass);element.parentNode.insertBefore(wrapper,element);wrapper.appendChild(element)}});window.addEventListener("scroll",function(){_this.updateItems()});window.addEventListener("resize",function(){_this.updateItems()});this.updateItems()}_createClass(ScrollHint,[{key:"isScrollable",value:function isScrollable(item){var offset=this.opt.offset;var element=item.element;var offsetWidth=element.offsetWidth;return offsetWidth+offset<element.scrollWidth}},{key:"checkScrollableDir",value:function checkScrollableDir(item){var _opt=this.opt,scrollHintBorderWidth=_opt.scrollHintBorderWidth,scrollableRightClass=_opt.scrollableRightClass,scrollableLeftClass=_opt.scrollableLeftClass;var element=item.element;var child=element.children[0];var width=child.scrollWidth;var parentWidth=element.offsetWidth;var scrollLeft=element.scrollLeft;if(parentWidth+scrollLeft<width-scrollHintBorderWidth){(0,_util.addClass)(element,scrollableRightClass)}else{(0,_util.removeClass)(element,scrollableRightClass)}if(parentWidth<width&&scrollLeft>scrollHintBorderWidth){(0,_util.addClass)(element,scrollableLeftClass)}else{(0,_util.removeClass)(element,scrollableLeftClass)}}},{key:"needSuggest",value:function needSuggest(item){var scrolledIn=item.scrolledIn,interacted=item.interacted;return!interacted&&scrolledIn&&this.isScrollable(item)}},{key:"updateItems",value:function updateItems(){var _this2=this;[].forEach.call(this.items,function(item){_this2.updateItem(item)})}},{key:"updateStatus",value:function updateStatus(item){var _this3=this;var element=item.element,scrolledIn=item.scrolledIn;if(scrolledIn){return}var target=element.querySelector('[data-target="scrollable-icon"] > span');if((0,_util.getOffset)(target).top<(0,_util.getScrollTop)()+window.innerHeight){item.scrolledIn=true;if(this.opt.remainingTime!==-1){setTimeout(function(){item.interacted=true;_this3.updateItem(item)},this.opt.remainingTime)}}}},{key:"updateItem",value:function updateItem(item){var opt=this.opt;var element=item.element;var target=element.querySelector('[data-target="scrollable-icon"]');this.updateStatus(item);if(this.isScrollable(item)){(0,_util.addClass)(element,opt.scrollableClass)}else{(0,_util.removeClass)(element,opt.scrollableClass)}if(this.needSuggest(item)){(0,_util.addClass)(target,opt.suggestClass)}else{(0,_util.removeClass)(target,opt.suggestClass)}if(opt.suggestiveShadow){this.checkScrollableDir(item)}}}]);return ScrollHint}();exports.default=ScrollHint;module.exports=exports["default"]},{"./util":3,"es6-object-assign":1}],3:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});var append=exports.append=function append(element,string){var div=document.createElement("div");div.innerHTML=string;while(div.children.length>0){element.appendChild(div.children[0])}};var addClass=exports.addClass=function addClass(element,className){if(element.classList){element.classList.add(className)}else{element.className+=" "+className}};var removeClass=exports.removeClass=function removeClass(element,className){if(element.classList){element.classList.remove(className)}else{element.className=element.className.replace(new RegExp("(^|\\b)"+className.split(" ").join("|")+"(\\b|$)","gi")," ")}};var getScrollTop=exports.getScrollTop=function getScrollTop(){return window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0};var getScrollLeft=exports.getScrollLeft=function getScrollLeft(){return window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft||0};var getOffset=exports.getOffset=function getOffset(el){var rect=el.getBoundingClientRect();return{top:rect.top+getScrollTop(),left:rect.left+getScrollLeft()}}},{}]},{},[2])(2)});

(() => {
	const siteName = 'sumisei';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 110,
				sp: 126
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						// data-header-behavior スクリプトを削除（同サイト読み込み時は実行しない）
						ele = ele.replace(/<script[^>]*data-header-behavior[^>]*>[\s\S]*?<\/script>/gi, '');

						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				// 直接の子要素のみを対象にする（ネストされたアコーディオンの+は除外）
				const plus = Array.from(ele.querySelectorAll('.mod-accordion-plus')).find(p => p.closest('.js-accordion') === ele);
				// ._detailタイプのアコーディオンのテキスト切り替え用要素
				const closeTextSpan = ele.classList.contains('_detail') ? ele.querySelector('.__close span span') : null;
				
				// デフォルトで開いている場合の初期設定
				if (ele.open) {
					if (plus) {
						plus.animate(
							{ rotate: ['90deg', '90deg'] },
							{
								duration: 0,
								pseudoElement: "::after",
								fill: 'forwards',
							}
						);
					}
					// デフォルトで開いている場合はテキストを「閉じる」に設定
					if (closeTextSpan) {
						closeTextSpan.textContent = '閉じる';
					}
				} else {
					// デフォルトで閉じている場合はテキストを「開く」に設定
					if (closeTextSpan) {
						closeTextSpan.textContent = '開く';
					}
				}
				
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						// 閉じる処理：現在の高さを取得してアニメーション
						const currentHeight = wrapper.scrollHeight;
						wrapper.style.height = currentHeight + 'px';
						wrapper.style.overflow = 'hidden';

						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [currentHeight + 'px', '0px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						// plusが存在する場合のみアニメーションを実行
						if (plus) {
							plus.animate(
								{ rotate: ['90deg', '0deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						// ._detailタイプの場合、テキストを「開く」に変更
						if (closeTextSpan) {
							closeTextSpan.textContent = '開く';
						}
						close.onfinish = () => {
							ele.removeAttribute('open');
							wrapper.style.height = '';
							wrapper.style.overflow = '';
						}
					} else {
						// 開く処理：要素を開いた状態にしてから高さを測定
						ele.setAttribute('open', 'true');
						wrapper.style.height = '0px';
						wrapper.style.overflow = 'hidden';

						// 次のフレームで実際の高さを取得してアニメーション開始
						requestAnimationFrame(() => {
							const targetHeight = wrapper.scrollHeight;

							wrapper.animate(
								{
									opacity: [0, 1],
									height: ['0px', targetHeight + 'px'],
								},
								{
									duration: 300,
									easing: 'ease',
								}
							).onfinish = () => {
								wrapper.style.height = '';
								wrapper.style.overflow = '';
							};
						});

						// plusが存在する場合のみアニメーションを実行
						if (plus) {
							plus.animate(
								{ rotate: ['0deg', '90deg'] },
								{
									duration: 300,
									pseudoElement: "::after",
									easing: 'ease',
									fill: 'forwards',
								}
							);
						}
						// ._detailタイプの場合、テキストを「閉じる」に変更
						if (closeTextSpan) {
							closeTextSpan.textContent = '閉じる';
						}
					}
				});
			});
		},
		spAccordion() {
			const spBreakpoint = 1024;
			const accordionTriggers = document.querySelectorAll('.js-spAcc');

			accordionTriggers.forEach(trigger => {
				trigger.addEventListener('click', (e) => {
					// 1024px以下の場合のみアコーディオン動作
					if (window.innerWidth <= spBreakpoint) {
						e.preventDefault(); // リンク遷移を無効化

						const nextElement = trigger.nextElementSibling;
						if (nextElement) {
							// is-activeクラスをトグル
							trigger.classList.toggle(a);

							if (trigger.classList.contains(a)) {
								// アコーディオンを開く
								nextElement.style.display = 'block';
								nextElement.style.overflow = 'hidden';
								nextElement.style.height = '0px';
								nextElement.style.transition = 'height 0.3s ease';

								// 実際の高さを取得
								const height = nextElement.scrollHeight;

								requestAnimationFrame(() => {
									nextElement.style.height = height + 'px';
								});

								// アニメーション完了後にheightをautoに戻す
								setTimeout(() => {
									nextElement.style.height = 'auto';
									nextElement.style.overflow = 'visible';
								}, 300);
							} else {
								// アコーディオンを閉じる
								const height = nextElement.scrollHeight;
								nextElement.style.overflow = 'hidden';
								nextElement.style.height = height + 'px';
								nextElement.style.transition = 'height 0.3s ease';

								requestAnimationFrame(() => {
									nextElement.style.height = '0px';
								});

								// アニメーション完了後に完全に非表示
								setTimeout(() => {
									nextElement.style.display = 'none';
								}, 300);
							}
						}
					}
					// 1024px超過の場合は通常のリンク遷移
				});
			});

			// リサイズ時の処理
			window.addEventListener('resize', () => {
				if (window.innerWidth > spBreakpoint) {
					// PC表示時は全てリセット
					accordionTriggers.forEach(trigger => {
						trigger.classList.remove(a);
						const nextElement = trigger.nextElementSibling;
						if (nextElement) {
							nextElement.style.display = 'block';
							nextElement.style.height = 'auto';
							nextElement.style.transition = '';
							nextElement.style.overflow = 'visible';
						}
					});
				} else {
					// SP表示時は閉じた状態に初期化
					accordionTriggers.forEach(trigger => {
						if (!trigger.classList.contains(a)) {
							const nextElement = trigger.nextElementSibling;
							if (nextElement) {
								nextElement.style.display = 'none';
							}
						}
					});
				}
			});
		},
		accBtn() {
			const accButtons = document.querySelectorAll('.js-accBtn');

			accButtons.forEach(button => {
				// .__close span span要素を取得（テキスト切り替え用）
				const closeTextSpan = button.querySelector('.__close span span');
				
				// 初期状態の設定
				const nextElement = button.nextElementSibling;
				const isInitiallyOpen = button.classList.contains(a) || 
					(nextElement && nextElement.style.display !== 'none' && nextElement.style.display !== '');
				
				if (closeTextSpan) {
					closeTextSpan.textContent = isInitiallyOpen ? '閉じる' : '開く';
				}
				
				button.addEventListener('click', (e) => {
					e.preventDefault();

					// is-activeクラスをトグル
					button.classList.toggle(a);

					// 次の要素を取得
					const nextElement = button.nextElementSibling;

					if (nextElement) {
						// jQueryのslideToggle相当の処理
						if (nextElement.style.display === 'none' || !nextElement.style.display) {
							// 開く処理
							nextElement.style.display = 'block';
							nextElement.style.height = '0px';
							nextElement.style.overflow = 'hidden';

							const height = nextElement.scrollHeight;

							requestAnimationFrame(() => {
								nextElement.style.transition = 'height 0.3s ease';
								nextElement.style.height = height + 'px';
							});

							setTimeout(() => {
								nextElement.style.height = 'auto';
								nextElement.style.overflow = 'visible';
							}, 300);
							
							// テキストを「閉じる」に変更
							if (closeTextSpan) {
								closeTextSpan.textContent = '閉じる';
							}
						} else {
							// 閉じる処理
							const height = nextElement.scrollHeight;
							nextElement.style.height = height + 'px';
							nextElement.style.overflow = 'hidden';

							requestAnimationFrame(() => {
								nextElement.style.transition = 'height 0.3s ease';
								nextElement.style.height = '0px';
							});

							setTimeout(() => {
								nextElement.style.display = 'none';
								nextElement.style.height = '';
								nextElement.style.overflow = '';
							}, 300);
							
							// テキストを「開く」に変更
							if (closeTextSpan) {
								closeTextSpan.textContent = '開く';
							}
						}
					}
				});
			});
		},
		// アクティブタブを画面内にスクロールする（JSタブ切り替え用）
		scrollToActiveTab(activeTab) {
			const tabContainer = activeTab.closest('.mod-tab-btns._scroll2');
			if (!tabContainer) return;

			// スクロール可能かチェック
			if (tabContainer.scrollWidth <= tabContainer.clientWidth) return;

			// アクティブタブの位置を取得
			const tabRect = activeTab.getBoundingClientRect();
			const containerRect = tabContainer.getBoundingClientRect();

			// アクティブタブが画面外にいるかチェック
			if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
				// タブを中央に配置
				const scrollLeft = activeTab.offsetLeft - (tabContainer.clientWidth / 2) + (activeTab.offsetWidth / 2);
				tabContainer.scrollTo({
					left: scrollLeft,
					behavior: 'smooth'
				});
			}
		},
		// リンク型タブのアクティブタブを右端に表示（ページ読み込み時）
		scrollToActiveTabLink() {
			const tabContainers = document.querySelectorAll('.mod-tab-btns._scroll2');
			
			tabContainers.forEach(container => {
				const activeTab = container.querySelector('.mod-tab-item.is-active');
				
				// アクティブタブが存在しない場合はスキップ
				if (!activeTab) return;
				
				// スクロール可能かチェック
				if (container.scrollWidth <= container.clientWidth) return;
				
				// 実際の表示領域を考慮した計算
				const containerRect = container.getBoundingClientRect();
				const activeTabRect = activeTab.getBoundingClientRect();
				
				// 現在のスクロール位置
				const currentScrollLeft = container.scrollLeft;
				
				// アクティブタブの右端の位置（スクロール位置を考慮）
				const activeTabRight = activeTabRect.right - containerRect.left + currentScrollLeft;
				
				// コンテナの実際の表示幅（paddingなどを考慮）
				const containerWidth = container.clientWidth;
				
				// アクティブタブの右端が画面外にいる場合のみスクロール
				if (activeTabRight > containerWidth) {
					// アクティブタブの右端がコンテナの右端にぴったり来るように調整
					const scrollLeft = activeTabRight - containerWidth;
					container.scrollTo({
						left: scrollLeft,
						behavior: 'smooth'
					});
				}
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
							// ページ読み込み時にアクティブタブをスクロール
							setTimeout(() => {
								FUNCTIONS.scrollToActiveTab(ele);
							}, 300);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
							setTimeout(() => {
								ele.classList.add(v);
								// タブコンテンツ表示後にmatchHeightを再実行
								FUNCTIONS.matchHeight();
							}, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						// クリック時にアクティブタブをスクロール
						FUNCTIONS.scrollToActiveTab(ele);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						
						// URLハッシュを更新
						if (target && target !== 'all') {
							history.replaceState(null, '', '#' + target);
						} else if (target === 'all') {
							history.replaceState(null, '', location.pathname);
						}
						
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => {
								ele.classList.add(v);
								// タブコンテンツ表示後にmatchHeightを再実行
								FUNCTIONS.matchHeight();
							}, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			// ページロード後の初回スクロールかどうかを判定
			let isFirstScroll = true;
			
			// swingイージング関数（jQuery風）
			const easeOutSwing = (t) => {
				return 0.5 - Math.cos(t * Math.PI) / 2;
			};
			
			// 手動スクロールアニメーション（swingイージング）
			const animateScroll = (to, duration) => {
				return new Promise((resolve) => {
					const start = window.scrollY;
					const change = to - start;
					const startTime = performance.now();
					
					const animate = (currentTime) => {
						const elapsed = currentTime - startTime;
						const progress = Math.min(elapsed / duration, 1);
						const eased = easeOutSwing(progress);
						
						window.scrollTo(0, start + change * eased);
						
						if (progress < 1) {
							requestAnimationFrame(animate);
						} else {
							resolve();
						}
					};
					
					requestAnimationFrame(animate);
				});
			};
			
			const scrollToObject = async (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let targetElement = hash === 'pagetop' ? null : document.getElementById(hash);
				let pos = hash === 'pagetop' ? 0 : targetElement.getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				
				// 初回は素早めのswing、2回目以降はease
				if (isFirstScroll) {
					// swingイージング（600ms）
					await animateScroll(pos, 600);
					
					// 初回のみ位置調整を実行（lazy-loaded画像対応）
					if (hash !== 'pagetop' && targetElement) {
						let isScrolling = true;
						let lastScrollTime = Date.now();
						
						// ヘッダー高さを取得
						let headerHeight;
						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							headerHeight = FUNCTIONS.va.header.sp;
						} else {
							headerHeight = FUNCTIONS.va.header.desktop;
						}
						
						// ユーザーのスクロール操作を検知
						const stopAdjustment = () => {
							isScrolling = false;
						};
						window.addEventListener('wheel', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchstart', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchmove', stopAdjustment, { once: true, passive: true });
						
						const adjustScroll = () => {
							if (!isScrolling) return;
							
							const elementTop = targetElement.getBoundingClientRect().top;
							const currentScrollY = window.scrollY;
							const targetPosition = currentScrollY + elementTop - headerHeight;
							const diff = Math.abs(window.scrollY - targetPosition);
							
							// 位置が5px以上ずれている場合は調整（easeで）
							if (diff > 5) {
								window.scrollTo({ top: targetPosition, behavior: 'smooth' });
								lastScrollTime = Date.now();
							}
						};
						
						// スクロール監視: レイアウト変更で位置がずれたら再調整
						const scrollMonitor = setInterval(() => {
							if (!isScrolling) {
								clearInterval(scrollMonitor);
								return;
							}
							
							adjustScroll();
							
							// 500msスクロール調整がなければ完了とみなす
							if (Date.now() - lastScrollTime > 500) {
								isScrolling = false;
								clearInterval(scrollMonitor);
							}
						}, 100);
						
						// 最大3秒で強制終了
						setTimeout(() => {
							isScrolling = false;
							clearInterval(scrollMonitor);
						}, 3000);
					}
					
					// 初回フラグを解除
					isFirstScroll = false;
				} else {
					// 2回目以降は通常のeaseスクロールのみ
					window.scrollTo({ top: pos, behavior: 'smooth' });
				}
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const targetElement = document.getElementById(hash);
					if (targetElement) {
						// アンカーターゲット要素自体をフォーカス可能にする
						if (!targetElement.hasAttribute('tabindex')) {
							targetElement.setAttribute('tabindex', '-1');
						}
						targetElement.focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			// #legacy_contents内のリンクは除外(import_legacy.jsで処理)
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				// #legacy_contents内のa[href^="#"]は除外
				if (ele.closest('#legacy_contents') && ele.getAttribute('href')?.startsWith('#')) {
					return;
				}
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						await scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				window.addEventListener('load', () => {
					const targetElement = document.getElementById(hash.split('#')[1]);
					let pos = targetElement.getBoundingClientRect().top;
					let offset = window.scrollY;
					pos += offset;
					
					let headerHeight;
					if (window.innerWidth < FUNCTIONS.va.device.sp) {
						headerHeight = FUNCTIONS.va.header.sp;
					} else {
						headerHeight = FUNCTIONS.va.header.desktop;
					}
					pos = pos - headerHeight;
					
					window.scrollTo({ top: pos, behavior: 'smooth' });
					
					// 微調整ロジック: レイアウト変更による位置ずれを補正
					let isAdjusting = true;
					let lastScrollTime = Date.now();
					
					// ユーザーのスクロール操作を検知
					const stopAdjustment = () => {
						isAdjusting = false;
					};
					window.addEventListener('wheel', stopAdjustment, { once: true, passive: true });
					window.addEventListener('touchstart', stopAdjustment, { once: true, passive: true });
					window.addEventListener('touchmove', stopAdjustment, { once: true, passive: true });
					
					const adjustScroll = () => {
						if (!isAdjusting) return;
						
						const elementTop = targetElement.getBoundingClientRect().top;
						const currentScrollY = window.scrollY;
						const targetPosition = currentScrollY + elementTop - headerHeight;
						const diff = Math.abs(window.scrollY - targetPosition);
						
						// 位置が5px以上ずれている場合は調整
						if (diff > 5) {
							window.scrollTo({ top: targetPosition, behavior: 'smooth' });
							lastScrollTime = Date.now();
						}
					};
					
					// スクロール監視: レイアウト変更で位置がずれたら再調整
					const scrollMonitor = setInterval(() => {
						if (!isAdjusting) {
							clearInterval(scrollMonitor);
							return;
						}
						
						adjustScroll();
						
						// 500msスクロール調整がなければ完了とみなす
						if (Date.now() - lastScrollTime > 500) {
							isAdjusting = false;
							clearInterval(scrollMonitor);
						}
					}, 100);
					
					// 最大3秒で強制終了
					setTimeout(() => {
						isAdjusting = false;
						clearInterval(scrollMonitor);
					}, 3000);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		popup() {
			// 通常サイズのポップアップ設定
			const pop_w = 800;
			const pop_h = 900;
			const pos_x = Number((screen.width - pop_w) / 2);
			const pos_y = Number((screen.height - pop_h) / 2);
			const pop_name = "popupWindow";
			const option = `width=${pop_w}, height=${pop_h}, left=${pos_x}, top=${pos_y}, scrollbars=yes`;

			// 大きいサイズのポップアップ設定
			const popL_w = 1010;
			const popL_h = 675;
			const posL_x = Number((screen.width - popL_w) / 2);
			const posL_y = Number((screen.height - popL_h) / 2);
			const popL_name = "popupWindow_L";
			const option_L = `width=${popL_w}, height=${popL_h}, left=${posL_x}, top=${posL_y}, scrollbars=yes`;

			// ポップアップを開く関数
			const popupFunc = (elem) => {
				const getURL = elem.getAttribute('href');
				if (elem.classList.contains('js-popup')) {
					window.open(getURL, pop_name, option);
				} else if (elem.classList.contains('js-popup_L')) {
					window.open(getURL, popL_name, option_L);
				}
			};

			// 通常サイズのポップアップ（js-popup）
			document.addEventListener('click', (e) => {
				if (e.target.closest('a.js-popup')) {
					e.preventDefault();
					e.stopPropagation();
					popupFunc(e.target.closest('a.js-popup'));
				}
			});

			// 大きいサイズのポップアップ（js-popup_L）
			document.addEventListener('click', (e) => {
				if (e.target.closest('a.js-popup_L')) {
					e.preventDefault();
					e.stopPropagation();
					popupFunc(e.target.closest('a.js-popup_L'));
				}
			});

			// 閉じるボタン（ポップアップウィンドウ内で使用）
			const closeBtn = document.querySelector('#close a');
			if (closeBtn) {
				closeBtn.addEventListener('click', (e) => {
					e.preventDefault();
					window.close();
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML, _target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					
					// YouTube動画モーダルの場合はiframe部分のクリックを無効化
					const movieModal = $container.querySelector('.mod-modalContent_inner._movie');
					if (movieModal) {
						movieModal.addEventListener('click', (e) => {
							e.stopPropagation();
						});
					}
					
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus({ preventScroll: true });
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
									document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus({ preventScroll: true });
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					e.preventDefault();
					
					// YouTube動画モーダルの場合
					if (ele.classList.contains('_video')) {
						const youtubeUrl = ele.getAttribute('href');
						if (!youtubeUrl) return false;
						
						// YouTube URLからビデオIDを抽出
						let videoId = '';
						const urlPatterns = [
							/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\?\/]+)/,
							/youtube\.com\/.*[?&]v=([^&]+)/
						];
						
						for (let pattern of urlPatterns) {
							const match = youtubeUrl.match(pattern);
							if (match && match[1]) {
								videoId = match[1];
								break;
							}
						}
						
						if (!videoId) return false;
						
						const iframeHTML = `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}" 
							title="YouTube video player" frameborder="0" 
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
							allowfullscreen></iframe>`;
						
						const appendHTML = `<div class="mod-modal-closeArea"></div>
							<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
							<div class="mod-modalContent_inner _movie">${iframeHTML}</div>`;
						
						createModal(appendHTML, e.currentTarget);
						return false;
					}
					
					// 通常の画像モーダル
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			if (!$elements.length) return;

			const groups = new Map();

			// 画像読み込み完了を待つ
			const images = [];
			$elements.forEach(ele => {
				const imgs = ele.querySelectorAll('img');
				imgs.forEach(img => {
					if (!img.complete) {
						images.push(new Promise(resolve => {
							img.addEventListener('load', resolve);
							img.addEventListener('error', resolve);
						}));
					}
				});
			});

			// 高さを揃える処理
			const syncHeights = () => {
				$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化
				console.log('matchHeight: Found elements:', $elements.length);

				$elements.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					if (!groups.has(attributeName)) {
						groups.set(attributeName, []);
					}
					groups.get(attributeName).push(ele);
				});
				
				groups.forEach((group, attributeName) => {
					console.log(`Processing group "${attributeName}":`, group.length, 'elements');
					
					// 同じ属性値の要素を行ごとにグループ化（±8pxの許容範囲に拡大）
					const rows = [];
					group.forEach(ele => {
						const topPosition = ele.getBoundingClientRect().top;
						console.log(`Element top position: ${topPosition}`);
						
						// 既存の行に追加できるかチェック
						let addedToRow = false;
						for (let row of rows) {
							const firstElementTop = row[0].getBoundingClientRect().top;
							const difference = Math.abs(topPosition - firstElementTop);
							console.log(`Comparing with row top ${firstElementTop}, difference: ${difference}`);
							if (difference <= 8) { // 許容範囲を8pxに拡大
								row.push(ele);
								addedToRow = true;
								console.log('Added to existing row');
								break;
							}
						}
						
						// どの行にも追加できなかった場合、新しい行を作成
						if (!addedToRow) {
							rows.push([ele]);
							console.log('Created new row');
						}
					});
					
					console.log(`Created ${rows.length} rows for "${attributeName}"`);
					
					// 各行で最大の高さに揃える
					rows.forEach((row, index) => {
						console.log(`Row ${index}: ${row.length} elements`);
						if (row.length > 1) { // 横並びの場合のみ
							const maxHeight = Math.max(...row.map(ele => ele.offsetHeight));
							console.log(`Setting height to ${maxHeight}px for ${row.length} elements`);
							row.forEach(ele => {
								ele.style.height = `${maxHeight}px`;
							});
						} else {
							console.log('Single element row - no height adjustment needed');
						}
					});
				});
			};

			// 画像があれば読み込み完了後、なければすぐに実行
			if (images.length > 0) {
				Promise.all(images).then(syncHeights);
			} else {
				syncHeights();
			}
		},
		heightSync() {
			const $elements = document.querySelectorAll('[data-hsync]');
			if (!$elements.length) return;

			const groups = new Map();

			// 画像読み込み完了を待つ
			const images = [];
			$elements.forEach(ele => {
				const imgs = ele.querySelectorAll('img');
				imgs.forEach(img => {
					if (!img.complete) {
						images.push(new Promise(resolve => {
							img.addEventListener('load', resolve);
							img.addEventListener('error', resolve);
						}));
					}
				});
			});

			// 高さを揃える処理
			const syncHeights = () => {
				$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

				$elements.forEach(ele => {
					const attributeName = ele.getAttribute('data-hsync');
					if (!groups.has(attributeName)) {
						groups.set(attributeName, []);
					}
					groups.get(attributeName).push(ele);
				});

				groups.forEach(group => {
					const rows = new Map();

					// 同じ行(Y座標)にある要素をグループ化
					group.forEach(ele => {
						const topPosition = Math.round(ele.getBoundingClientRect().top);
						if (!rows.has(topPosition)) {
							rows.set(topPosition, []);
						}
						rows.get(topPosition).push(ele);
					});

					// 各行で最大の高さに揃える
					rows.forEach(rowElements => {
						if (rowElements.length > 1) { // 横並びの場合のみ
							const maxHeight = Math.max(...rowElements.map(ele => ele.offsetHeight));
							rowElements.forEach(ele => {
								ele.style.height = `${maxHeight}px`;
							});
						}
					});
				});
			};

			// 画像があれば読み込み完了後、なければすぐに実行
			if (images.length > 0) {
				Promise.all(images).then(syncHeights);
			} else {
				syncHeights();
			}
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		inViewAnimationHeadImg() {
			const target = document.querySelectorAll('.mod-head, .mod-title');
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty() {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		hideEmptyElements() {
			// js-emptyHideクラスを持つ要素で子要素がない場合に削除
			const $elements = document.querySelectorAll('.js-emptyHide');
			$elements.forEach(ele => {
				// 子要素の数をチェック(テキストノードや空白は除く)
				const hasChildren = Array.from(ele.children).some(child => {
					// 非表示の要素やコメントノードは除外
					return child.nodeType === 1 && !child.classList.contains('di_none');
				});
				
				if (!hasChildren) {
					ele.remove();
				}
			});
		},
		removeEmptyLinks() {
			// href属性が空のaタグにtabindex="-1"を追加してタブキーで選択されないようにする
			const links = document.querySelectorAll('a');
			links.forEach(link => {
				const href = link.getAttribute('href');
				
				// hrefが空または空白のみの場合、tabindex="-1"を追加
				if (!href || href.trim() === '') {
					link.setAttribute('tabindex', '-1');
				}
			});
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		pcHeaderMegamenu() {
			if (document.querySelectorAll('.js-header-nav-mega').length) {
				const $header = document.querySelector('.header');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				const closeAllMegaMenus = () => {
					$header.classList.remove(a);
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling) {
							btn.nextElementSibling.classList.remove(a);
						}
					});
				};
				// メガメニューのホバーイベント処理
				// .header-nav-mega > li 要素を取得
				const $megaMenuItems = document.querySelectorAll('.header-nav-mega > li');

				// メガメニューを開く共通処理
				const openMegaMenu = (menuItem) => {
					const btn = menuItem.querySelector('.js-header-nav-mega-btn');
					const menuNav = btn ? btn.nextElementSibling : null;

					// 他のメガメニューを閉じる
					$megabtn.forEach(otherBtn => {
						if (otherBtn !== btn) {
							otherBtn.classList.remove(a);
							if (otherBtn.nextElementSibling) {
								otherBtn.nextElementSibling.classList.remove(a);
							}
						}
					});

					// 現在のメニューを開く（メガメニューボタンがある場合のみ）
					if (btn && menuNav) {
						$header.classList.add(a);
						btn.classList.add(a);
						menuNav.classList.add(a);
					} else {
						// aタグのみの場合は、すべてのメガメニューを閉じる
						closeAllMegaMenus();
					}
				};

				$megaMenuItems.forEach(menuItem => {
					let hoverTimeout;

					// ホバー開始時
					menuItem.addEventListener('mouseenter', (e) => {
						clearTimeout(hoverTimeout);
						// 0.2秒後にメガメニューを表示
						hoverTimeout = setTimeout(() => {
							openMegaMenu(menuItem);
						}, 150);
					});

					// ホバー終了時
					menuItem.addEventListener('mouseleave', (e) => {
						// タイムアウトをクリア（メニューが開く前に離れた場合は開かない）
						clearTimeout(hoverTimeout);
						// すぐにメニューを閉じる
						const btn = menuItem.querySelector('.js-header-nav-mega-btn');
						if (btn && btn.classList.contains(a)) {
							closeAllMegaMenus();
						}
					});

					// フォーカスイン時（キーボード操作対応）
					menuItem.addEventListener('focusin', (e) => {
						clearTimeout(hoverTimeout);
						openMegaMenu(menuItem);
					});

					// フォーカスアウト時（キーボード操作対応）
					menuItem.addEventListener('focusout', (e) => {
						// 少し遅延を設けて、フォーカスが別のメニューアイテムに移動するのを許可
						setTimeout(() => {
							const focusedElement = document.activeElement;
							const isInsideMenuItem = menuItem.contains(focusedElement);
							
							// フォーカスがメニューアイテム外に出た場合のみ閉じる
							if (!isInsideMenuItem) {
								const btn = menuItem.querySelector('.js-header-nav-mega-btn');
								if (btn && btn.classList.contains(a)) {
									closeAllMegaMenus();
								}
							}
						}, 0);
					});
				});

				// メガメニューコンテンツ自体にホバー時は閉じないようにする
				$megamenu.forEach(menu => {
					menu.addEventListener('mouseenter', () => {
						// メニューコンテンツ内にいる間は閉じる処理をクリア
						const parentMenuItem = menu.closest('.header-nav-mega > li');
						if (parentMenuItem) {
							clearTimeout(parentMenuItem.hoverTimeout);
						}
					});
				});

				// メガメニュー外のクリックで閉じる
				document.addEventListener("click", (event) => {
					const target = event.target;
					const isClickInsideNav = [...$megamenu]
						.some(el => el.contains(target));
					const isClickOnMegaItem = [...$megaMenuItems]
						.some(item => item.contains(target));

					if (!isClickInsideNav && !isClickOnMegaItem && $header.classList.contains(a)) {
						closeAllMegaMenus();
					}
				});
				//js-megamenuCloseで閉じる
				document.querySelectorAll('.js-megamenuClose').forEach(ele => {
					ele.addEventListener('click', () => {
						closeAllMegaMenus();
					});
				});

				// ESCキーでメガメニューを閉じる
				window.addEventListener("keydown", function (event) {
					if ($header.classList.contains(a)) {
						if (event.key === "Escape") {
							event.preventDefault();
							closeAllMegaMenus();
						}
					}
				});

				//メガメニュー内のサブメニュー表示切り替え（ホバー対応）
				const megaSubMenuButtons = document.querySelectorAll('.mod-megaLinkWrap .__linkInner .__linkList > li > button');
				const allLowerLists = document.querySelectorAll('.mod-megaLinkWrap .__linkInner .__linkList > li .__lowerList');
				const megaSubMenuItems = document.querySelectorAll('.mod-megaLinkWrap .__linkInner .__linkList > li');

				// サブメニューを開く共通処理
				const openSubMenu = (menuItem) => {
					const button = menuItem.querySelector('button');
					const lowerList = menuItem.querySelector('.__lowerList');

					// すべての.__lowerListからis-activeクラスを削除
					allLowerLists.forEach(lowerList => {
						lowerList.classList.remove(a);
					});

					// 対象のアイテムの.__lowerListにis-activeクラスを追加
					if (lowerList) {
						lowerList.classList.add(a);
					}
				};

				megaSubMenuItems.forEach(menuItem => {
					let subHoverTimeout;

					// ホバー開始時
					menuItem.addEventListener('mouseenter', (e) => {
						clearTimeout(subHoverTimeout);
						openSubMenu(menuItem);
					});

					// ホバー終了時
					menuItem.addEventListener('mouseleave', (e) => {
						const lowerList = menuItem.querySelector('.__lowerList');

						// 少し遅延を設けて、サブメニューへの移動を許可
						subHoverTimeout = setTimeout(() => {
							if (lowerList && lowerList.classList.contains(a)) {
								lowerList.classList.remove(a);
							}
						}, 100);
					});

					// フォーカスイン時（キーボード操作対応）
					menuItem.addEventListener('focusin', (e) => {
						clearTimeout(subHoverTimeout);
						openSubMenu(menuItem);
					});

					// フォーカスアウト時（キーボード操作対応）
					menuItem.addEventListener('focusout', (e) => {
						const lowerList = menuItem.querySelector('.__lowerList');

						// 少し遅延を設けて、フォーカスが別の要素に移動するのを許可
						setTimeout(() => {
							const focusedElement = document.activeElement;
							const isInsideMenuItem = menuItem.contains(focusedElement);
							
							// フォーカスがメニューアイテム外に出た場合のみ閉じる
							if (!isInsideMenuItem && lowerList && lowerList.classList.contains(a)) {
								lowerList.classList.remove(a);
							}
						}, 0);
					});
				});

				// .__lowerList自体にホバー時は閉じないようにする
				allLowerLists.forEach(lowerList => {
					lowerList.addEventListener('mouseenter', () => {
						// サブメニュー内にいる間は閉じる処理をクリア
						const parentMenuItem = lowerList.closest('.mod-megaLinkWrap .__linkInner .__linkList > li');
						if (parentMenuItem) {
							clearTimeout(parentMenuItem.subHoverTimeout);
						}
					});
				});

				//メガメニュー高さ調整
				const adjustMegaMenuHeight = () => {
					document.querySelectorAll('.mod-megaLinkWrap').forEach(megaWrap => {
						// 初期化：min-heightをリセット
					megaWrap.style.minHeight = '';

					// 該当するmegaWrap内の.__lowerListの高さを取得
					const lowerLists = megaWrap.querySelectorAll('.__linkInner .__linkList > li .__lowerList');
					let maxHeight = 0;

					lowerLists.forEach(lowerList => {
						// 一時的にvisibleにして高さを測定
						const originalDisplay = lowerList.style.display;
						const originalVisibility = lowerList.style.visibility;
						const originalPosition = lowerList.style.position;

						lowerList.style.display = 'block';
						lowerList.style.visibility = 'hidden';
						lowerList.style.position = 'absolute';

						const lowerListHeight = lowerList.offsetHeight;

						// 元のスタイルに戻す
						lowerList.style.display = originalDisplay;
						lowerList.style.visibility = originalVisibility;
						lowerList.style.position = originalPosition;

						// .__linkInnerの上部からの距離を考慮した高さを計算
						const linkInner = megaWrap.querySelector('.__linkInner');
						if (linkInner) {
							const linkInnerOffsetTop = linkInner.offsetTop;
							const totalHeight = linkInnerOffsetTop + lowerListHeight;
							maxHeight = Math.max(maxHeight, totalHeight);
						}
					});

					// 計算した高さを適用（最大の下層メニュー高さに合わせる）
					if (maxHeight > 0) {
						megaWrap.style.minHeight = `${maxHeight}px`;
					}
			});
		};

		// 初期実行
		adjustMegaMenuHeight();

		// リサイズ時の実行
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				adjustMegaMenuHeight();
			}, 100);
		});
			}
		},
		spHeaderHamburger() {
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $container = document.querySelector('.container');
				let scrollTopNow;
				const fixedOnContainer = () => {
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					$container.querySelector('.contents').style.opacity = '0';
				};
				const fixedOffContainer = () => {
					$container.style.position = 'static';
					$container.querySelector('.contents').style.opacity = '1';
					window.scrollTo({ top: scrollTopNow });
				};
				$hamburger.addEventListener('click', (e) => {
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.ariaLabel = 'open'
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburger.ariaLabel = 'close'
					}
				});
				window.addEventListener("keydown", function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === "Tab") {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null); // 非表示要素を除外
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							console.log(focusedItemIndex, focusableElements);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === "Escape") {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'close'
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});

				//SPサブメニュー
				const spMenuButtons = document.querySelectorAll('.mod-spHeadMenu .__menu > li > button');
				const allInnerMenus = document.querySelectorAll('.mod-spHeadMenu .__innnerMenu');

				spMenuButtons.forEach(button => {
					button.addEventListener('click', (e) => {
						e.preventDefault();

						// 現在のボタンの次の要素（.__innnerMenu）を取得
						const currentInnerMenu = button.nextElementSibling;
						const isCurrentActive = currentInnerMenu && currentInnerMenu.classList.contains(a);

						// すべてのボタンからis-activeクラスを削除
						spMenuButtons.forEach(btn => {
							btn.classList.remove(a);
						});

						// すべての.__innnerMenuからis-activeクラスを削除
						allInnerMenus.forEach(innerMenu => {
							innerMenu.classList.remove(a);
						});

						// 現在のメニューがアクティブでなかった場合のみ、is-activeクラスを追加
						if (currentInnerMenu && currentInnerMenu.classList.contains('__innnerMenu') && !isCurrentActive) {
							button.classList.add(a);
							currentInnerMenu.classList.add(a);
						}
					});
				});

				// .__innnerMenu内のjs-closeボタンでメニューを閉じる
				document.querySelectorAll('.mod-spHeadMenu .__innnerMenu .js-close').forEach(closeBtn => {
					closeBtn.addEventListener('click', (e) => {
						e.preventDefault();

						// すべてのボタンからis-activeクラスを削除
						spMenuButtons.forEach(btn => {
							btn.classList.remove(a);
						});

						// すべての.__innnerMenuからis-activeクラスを削除
						allInnerMenus.forEach(innerMenu => {
							innerMenu.classList.remove(a);
						});
					});
				});

				// アコーディオン開閉のアニメーション関数
				const slideToggle = (element, duration = 300) => {
					if (element.classList.contains('is-animating')) return;

					element.classList.add('is-animating');

					if (element.style.display === 'none' || !element.classList.contains(a)) {
						// 開く動作
						element.style.display = 'block';
						element.style.height = '0px';
						element.style.overflow = 'hidden';
						element.style.transition = `height ${duration}ms ease`;

						// 実際の高さを計算
						const scrollHeight = element.scrollHeight;

						// アニメーション開始
						requestAnimationFrame(() => {
							element.style.height = scrollHeight + 'px';
							element.classList.add(a);
						});

						// アニメーション終了時の処理
						setTimeout(() => {
							element.style.height = '';
							element.style.overflow = '';
							element.style.transition = '';
							element.classList.remove('is-animating');
						}, duration);

					} else {
						// 閉じる動作
						element.style.height = element.scrollHeight + 'px';
						element.style.overflow = 'hidden';
						element.style.transition = `height ${duration}ms ease`;

						requestAnimationFrame(() => {
							element.style.height = '0px';
							element.classList.remove(a);
						});

						// アニメーション終了時の処理
						setTimeout(() => {
							element.style.display = 'none';
							element.style.height = '';
							element.style.overflow = '';
							element.style.transition = '';
							element.classList.remove('is-animating');
						}, duration);
					}
				};

				// .header-nav-sp .__spMenuList>li>buttonのアコーディオン動作
				const spMenuListButtons = document.querySelectorAll('.header-nav-sp .__spMenuList > li > button');

				spMenuListButtons.forEach(button => {
					button.addEventListener('click', (e) => {
						e.preventDefault();

						// 現在のボタンの次の要素（.__innerWrap）を取得
						const nextElement = button.nextElementSibling;
						const innerWrap = nextElement && nextElement.classList.contains('__innerWrap') ? nextElement : null;

						if (innerWrap) {
							// 自身のis-activeクラスをトグル
							button.classList.toggle(a);

							// アコーディオンアニメーション付きで開閉
							slideToggle(innerWrap, 300);
						}
					});
				});

				// .header-nav-sp .__subWrap .js-closeでハンバーガーメニューを閉じる
				document.querySelectorAll('.header-nav-sp .__subWrap .js-close').forEach(closeBtn => {
					closeBtn.addEventListener('click', (e) => {
						e.preventDefault();

						// ハンバーガーメニューを閉じる（.header-hamburgerをクリックしたときと同じ動作）
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.ariaLabel = 'open';
						fixedOffContainer();
					});
				});

				// リサイズ時にPCサイズになったらハンバーガーメニューを閉じる
				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(() => {
						// PCサイズの判定（1024px以上）
						if (window.innerWidth >= FUNCTIONS.va.device.desktop) {
							// ハンバーガーメニューが開いている場合は閉じる
							if ($nav.classList.contains(a)) {
								$nav.classList.remove(a);
								$hamburger.classList.remove(a);
								$hamburger.ariaLabel = 'open';
								fixedOffContainer();
							}
						}
					}, 100);
				});
			}
		},
		removeTargetFade() {
			// js-removeボタンでdata-removeTarget要素をフェードアウト削除
			document.querySelectorAll('.js-remove').forEach(removeBtn => {
				removeBtn.addEventListener('click', (e) => {
					e.preventDefault();

					// 最も近いdata-removeTarget要素を取得
					const targetElement = removeBtn.closest('[data-removeTarget]');

					if (targetElement) {
						// フェードアウトアニメーション
						const fadeOut = targetElement.animate(
							{
								opacity: [1, 0]
							},
							{
								duration: 300,
								easing: 'ease-out',
								fill: 'forwards'
							}
						);

						// アニメーション完了後に要素を削除
						fadeOut.onfinish = () => {
							targetElement.remove();
						};
					}
				});
			});
		},
		currentSet(){
			// .mod-localNavがあるページで現在のURLに一致するリンクに is-current クラスを追加
			const localNavs = document.querySelectorAll('.mod-localNav');
			if (localNavs.length > 0) {
				localNavs.forEach(localNav => {
					// 現在のページのパスを取得（index.htmlを除去）
					const currentPath = location.pathname.replace(/index\.html$/, '');

					// .mod-localNav内の全てのaタグを取得
					const links = localNav.querySelectorAll('a[href]');

					links.forEach(link => {
						// 各リンクのhrefを取得し、絶対パスに変換
						const linkPath = new URL(link.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');

						// パスが完全に一致する場合
						if (currentPath === linkPath) {
							// 親要素のliを取得してis-currentクラスを追加
							const parentLi = link.closest('li');
							if (parentLi) {
								parentLi.classList.add('is-current');
							}
						}
					});
				});
			}
		},
		bnrCarousel() {
			const bnrCarousels = document.querySelectorAll('.js-bnrCarousel .splide');

			bnrCarousels.forEach(carousel => {
				const splide = new Splide(carousel, {
					type: 'loop',
					clones: 7,
					perMove: 1,
					autoWidth: true,
					autoplay: false,
					interval: 3000,
					speed: 1000,
					arrows: true,
					pagination: false,
					gap: '16px',
					focus: 'center',
					breakpoints: {
						1024: {
							gap: '12px',
						}
					}
				});

				// スライドカウント表示機能
				const updateSlideCount = () => {
					const currentEl = carousel.closest('.mod-bnrSection').querySelector('.splide__current');
					const totalEl = carousel.closest('.mod-bnrSection').querySelector('.splide__total');

					if (currentEl && totalEl) {
						// 現在のスライド番号（1から開始）
						const currentIndex = splide.index + 1;
						// 総スライド数
						const totalSlides = splide.length;

						// 一桁の場合は01～09形式でゼロパディング
						const formatNumber = (num) => num.toString().padStart(2, '0');

						currentEl.textContent = formatNumber(currentIndex);
						totalEl.textContent = formatNumber(totalSlides);
					}
				};

				// 初期表示
				splide.on('ready', () => {
					updateSlideCount();
				});

				// スライド変更開始時にカウントを更新（切り替わり始めるタイミング）
				splide.on('move', () => {
					updateSlideCount();
				});

				splide.mount();
			});
		},
		storySlider() {
			const bnrCarousels = document.querySelectorAll('.js-storySlider.splide');

			bnrCarousels.forEach(carousel => {
				// スライド数を取得
				const slides = carousel.querySelectorAll('.splide__slide');
				const slideCount = slides.length;
				
				// 1件の場合
				if (slideCount === 1) {
					carousel.classList.add('is-single');
					return;
				}
				
				// 2件の場合
				if (slideCount === 2) {
					carousel.classList.add('is-double');
				}

				const splide = new Splide(carousel, {
					type: 'loop',
					clones: 7,
					perMove: 1,
					autoWidth: true,
					autoplay: false,
					interval: 3000,
					speed: 1000,
					arrows: true,
					pagination: false,
					focus: 'left',
				});

				// スライドカウント表示機能
				const updateSlideCount = () => {
					const currentEl = carousel.closest('.mod-splideWrap').querySelector('.splide__current');
					const totalEl = carousel.closest('.mod-splideWrap').querySelector('.splide__total');

					if (currentEl && totalEl) {
						// 現在のスライド番号（1から開始）
						const currentIndex = splide.index + 1;
						// 総スライド数（クローンを除く実際のスライド数）
						const totalSlides = splide.Components.Slides.getLength(true);

						// 一桁の場合は01～09形式でゼロパディング
						const formatNumber = (num) => num.toString().padStart(2, '0');

						currentEl.textContent = formatNumber(currentIndex);
						totalEl.textContent = formatNumber(totalSlides);
					}
				};

				// 初期表示
				splide.on('ready', () => {
					updateSlideCount();
				});

				// スライド変更開始時にカウントを更新（切り替わり始めるタイミング）
				splide.on('move', () => {
					updateSlideCount();
				});

				splide.mount();
			});
		},
		cardSlider() {
			// カルーセル無効化設定（スライド3個以下、936px以上の時の特例処理のオン/オフ）
			const enableCarouselDisable = true; // false にすると特例処理を無効化
			
			const cardSliders = document.querySelectorAll('.js-cardSlider');

			cardSliders.forEach(carousel => {
				// スライド数を取得
				const slideCount = carousel.querySelectorAll('.splide__slide').length;
				
				let splide; // Splideインスタンスを外部で管理
				
				// Splideを初期化する関数
				const initSplide = () => {
					// 936px以上でスライドが3個以下の場合の特例処理
					const isSpecialCase = enableCarouselDisable && slideCount <= 3 && window.innerWidth >= 936;
					
					// 特例条件の場合、CSS調整用のクラスを追加
					if (isSpecialCase) {
						carousel.classList.add('is-carousel-disabled');
					} else {
						carousel.classList.remove('is-carousel-disabled');
					}
					
					// 既存のSplideがあれば破棄
					if (splide) {
						splide.destroy();
					}
					
					splide = new Splide(carousel, {
						type: isSpecialCase ? 'slide' : 'loop', // 特例時はloopを無効化
						perMove: 1,
						perPage: 3,
						autoplay: isSpecialCase ? false : true, // 特例時は自動再生を無効化
						arrows: true,
						pagination: false,
						gap: '40px',
						clones: isSpecialCase ? 0 : 3, // 特例時はクローンを無効化
						drag: isSpecialCase ? false : true, // 特例時はドラッグを無効化
						wheel: isSpecialCase ? false : true, // 特例時はマウスホイールを無効化
						breakpoints: {
							1024: {
								perPage: 1,
								autoWidth: true,
								gap: '16px',
							},
							935: {
								// 935px以下は通常通りカルーセル
								type: 'loop',
								autoplay: true,
								drag: true,
								wheel: true,
							}
						}
					});

					// スライドカウント表示機能
					// このcarouselに対応するラップ要素を取得
					const wrapEl = carousel.closest('.mod-splideWrap');
					
					if (wrapEl) {
						// このcarousel専用のDOM要素を取得
						// wrapEl内で、このcarouselの.splide__controlsに含まれる要素のみを取得
						const controlsEl = wrapEl.querySelector('.splide__controls');
						
						if (controlsEl) {
							const currentEl = controlsEl.querySelector('.splide__current');
							const totalEl = controlsEl.querySelector('.splide__total');
							
							if (currentEl && totalEl) {
								// 総スライド数をDOMから直接取得（クローンを除く）
								const originalSlides = carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
								const totalSlides = originalSlides.length;
								
								// 一桁の場合は01～09形式でゼロパディング
								const formatNumber = (num) => num.toString().padStart(2, '0');
								
								// 総数を設定（固定値）
								totalEl.textContent = formatNumber(totalSlides);
								
								// 前回のインデックスを保持
								let lastIndex = -1;
								
								const updateSlideCount = () => {
									const currentIndex = splide.index + 1;
									// インデックスが実際に変化した時のみ更新
									if (lastIndex !== currentIndex) {
										lastIndex = currentIndex;
										currentEl.textContent = formatNumber(currentIndex);
									}
								};

								// 初期表示
								splide.on('ready', () => {
									updateSlideCount();
								});

								// スライド変更完了時にカウントを更新
								splide.on('moved', () => {
									updateSlideCount();
								});
							}
						}
					}

					splide.mount();
				};
				
				// 初回実行
				initSplide();
				
				// リサイズ時の処理（デバウンス付き）
				let resizeTimer;
				let previousIsSpecialCase = enableCarouselDisable && slideCount <= 3 && window.innerWidth >= 936;
				
				window.addEventListener('resize', () => {
					// 既存のタイマーをクリア
					clearTimeout(resizeTimer);
					
					// 200ms後に処理を実行（リサイズが落ち着いてから実行）
					resizeTimer = setTimeout(() => {
						const currentWidth = window.innerWidth;
						const newIsSpecialCase = enableCarouselDisable && slideCount <= 3 && currentWidth >= 936;
						
						// 特例条件が変わった場合のみ再初期化
						if (previousIsSpecialCase !== newIsSpecialCase) {
							initSplide();
							previousIsSpecialCase = newIsSpecialCase;
						}
					}, 200);
				});
			});
		},
		addLinkClass() {
			// .mod-link01を持つすべてのaタグを取得
			const links = document.querySelectorAll('a.mod-link01');
			
			links.forEach(link => {
				// リンク内のすべてのuseタグを取得
				const useElements = link.querySelectorAll('use');
				
				useElements.forEach(use => {
					const href = use.getAttribute('href');
					
					// hrefに#blankが含まれる場合
					if (href && href.includes('#blank')) {
						link.classList.add('__blank');
					}
					
					// hrefに#pdfが含まれる場合
					if (href && href.includes('#pdf')) {
						link.classList.add('__pdf');
					}
				});
			});

			// .mod-buttonと.mod-button02を持つすべての要素を取得
			const buttons = document.querySelectorAll('.mod-button, .mod-button02');
			
			buttons.forEach(button => {
				// ボタン内のuseタグを取得
				const useElements = button.querySelectorAll('use');
				
				useElements.forEach(use => {
					const href = use.getAttribute('href');
					
					// hrefが/cnt_common/svg/sprite.svg#arrow2_rightの場合
					if (href && href === '/cnt_common/svg/sprite.svg#arrow2_right') {
						// _noAnimクラスを持つボタンはアニメーションを付与しない
						if (button.classList.contains('_noAnim')) return;
						// 親要素のspan._iconを取得
						const iconSpan = use.closest('span._icon');
						if (iconSpan) {
							iconSpan.classList.add('_anim');
						}
					}
				});
			});
		},
		addTableClass() {
			// .mod-tbl02を持つすべてのテーブルを取得
			const tables = document.querySelectorAll('.mod-tbl02');
			
			tables.forEach(table => {
				// テーブルの高さを取得
				const tableHeight = table.offsetHeight;
				
				// 高さが300px未満の場合、クラスを追加
				if (tableHeight < 300) {
					table.classList.add('_small');
				}
			});
		},
		largeCardeSlider() {
			const largeCardSliders = document.querySelectorAll('.js-largeCardSlider');

			largeCardSliders.forEach(carousel => {
				const splide = new Splide(carousel, {
					type: 'loop',
					perMove: 1,
					perPage: 1,
					autoplay: true,
					interval: 6500,
					speed: 1000,
					arrows: true,
					pagination: false,
					gap: '40px',
					focus: 'center',
					breakpoints: {
						768: {
							gap: '24px',
							autoWidth: true,
						}
					}
				});

				// スライドカウント表示機能
				const updateSlideCount = () => {
					const currentEl = carousel.querySelector('.splide__current');
					const totalEl = carousel.querySelector('.splide__total');

					if (currentEl && totalEl) {
						// 現在のスライド番号（1から開始）
						const currentIndex = splide.index + 1;
						// 総スライド数
						const totalSlides = splide.length;

						// 一桁の場合は01～09形式でゼロパディング
						const formatNumber = (num) => num.toString().padStart(2, '0');

						currentEl.textContent = formatNumber(currentIndex);
						totalEl.textContent = formatNumber(totalSlides);
					}
				};

				// 初期表示
				splide.on('ready', () => {
					updateSlideCount();
				});

				// スライド変更開始時にカウントを更新（切り替わり始めるタイミング）
				splide.on('move', () => {
					updateSlideCount();
				});

				splide.mount();
			});
		},
		initScrollHint() {
			// ScrollHintが利用可能かチェック
			if (typeof ScrollHint !== 'undefined') {
				const isEnglish = location.pathname.startsWith('/english/');
				// デフォルトのオプション設定
				const scrollHintOptions = {
					suggestClass: 'is-active',
					scrollableClass: 'is-scrollable',
					scrollableRightClass: 'is-right-scrollable',
					scrollableLeftClass: 'is-left-scrollable',
					scrollHintClass: 'scroll-hint',
					scrollHintIconClass: 'scroll-hint-icon',
					scrollHintIconWrapClass: 'scroll-hint-icon-wrap',
					scrollHintText: 'scroll-hint-text',
					remainingTime: 3000, // 3秒後にヒントを非表示
					enableOverflowScrolling: true,
					suggestiveShadow: false,
					i18n: {
						scrollable: isEnglish ? 'scrollable' : 'スクロールできます'
					}
				};

				// .js-scroll-hintクラスを持つ要素にScrollHintを適用
				const scrollHintElements = document.querySelectorAll('.js-scroll-hint');
				if (scrollHintElements.length > 0) {
					new ScrollHint(scrollHintElements, scrollHintOptions);
				}

				// .mod-tblWrap要素にScrollHintを適用
				const tblWrapElements = document.querySelectorAll('.mod-tblWrap');
				if (tblWrapElements.length > 0) {
					tblWrapElements.forEach(tblElement => {
						// 横スクロールが必要かチェック
						if (tblElement.scrollWidth > tblElement.offsetWidth) {
							new ScrollHint(tblElement, scrollHintOptions);
						}
					});
				}
			}
		},
		regNumber() {
			// .js-regNumber要素が存在するかチェック
			const regNumberElement = document.querySelector('.js-regNumber');
			if (!regNumberElement) return;

			// 現在のページパスを取得
			const currentPath = location.pathname;

			// JSONファイルのパスを構築
			const jsonUrl = `/ajax/lineup/product_registration_number.json?product_registration_number_id=${currentPath}`;

			// JSONデータを取得
			fetch(jsonUrl)
				.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.json();
				})
				.then(data => {
					// 登録番号を取得して表示
					if (data.rt_bn_product_registration_number && 
						Array.isArray(data.rt_bn_product_registration_number) && 
						data.rt_bn_product_registration_number.length > 0 &&
						data.rt_bn_product_registration_number[0].cf_prn_registration_number) {
						
						// テキストを空にしてから挿入
						regNumberElement.textContent = '';
						regNumberElement.textContent = data.rt_bn_product_registration_number[0].cf_prn_registration_number;
						
						// vis-hiddenクラスを削除
						regNumberElement.classList.remove('vis-hidden');
					}
				})
				.catch(error => {
					console.error(`Failed to load ${jsonUrl}:`, error);
				});
		},
		searchModal(){
			// js-searchToggleクリック時にsearchWidgetTriggerをトリガー
			const searchToggles = document.querySelectorAll('.js-searchToggle');
			searchToggles.forEach(searchToggle => {
				searchToggle.addEventListener('click', () => {
					const searchWidgetTrigger = document.getElementById('searchWidgetTrigger');
					if (searchWidgetTrigger) {
						searchWidgetTrigger.click();
					}
				});
			});
		},
		checkAppliParam() {
			// id="pagetop"の要素を取得
			const pagetop = document.getElementById('pagetop');
			
			// pagetopが存在し、特定のクラスを持つ場合のみ処理を実行
			// 例: pagetopに'js-app-enabled'クラスがある場合のみ実行
			// 必要に応じてクラス名を変更してください
			if (pagetop && pagetop.classList.contains('js-app-enabled')) {
				const urlParams = new URLSearchParams(window.location.search);
				if (urlParams.get('appli') === '1') {
					document.body.classList.add('is-app');
				}
			}

			// .js-contractPwがあるページでのQRコードパラメータ処理
			const contractPw = document.querySelector('.js-contractPw');
			if (contractPw) {
				const urlParams = new URLSearchParams(window.location.search);
				if (urlParams.get('qr') === '1') {
					// QRコードからのアクセスの場合はリダイレクト
					location.href = '/corporative/guidance/welfare/hospita/';
				} else {
					// QRコードパラメータがない場合はbodyのopacityを削除
					document.body.style.opacity = '1';
				}
			}

			// .js-showBtnクリックで.js-contractPwInnerを表示
			const showBtns = document.querySelectorAll('.js-contractPw .js-showBtn');
			showBtns.forEach(btn => {
				btn.addEventListener('click', function() {
					// 親の.js-contractPwを見つけて、その中の.js-contractPwInnerを表示
					const contractPw = this.closest('.js-contractPw');
					if (contractPw) {
						const inner = contractPw.querySelector('.js-contractPwInner');
						if (inner) {
							inner.style.display = 'block';
						}
					}
					// ボタンを削除
					this.remove();
				});
			});

			// パスワード認証処理
			const passwordInput = document.getElementById('input_01');
			const submitBtn = document.querySelector('.js-submitBtn');
			
			const checkPassword = () => {
				if (passwordInput && passwordInput.value === '7830') {
					location.href = '/corporative/guidance/welfare/hospita/';
				}
			};

			// エンターキーで認証
			if (passwordInput) {
				passwordInput.addEventListener('keypress', (e) => {
					if (e.key === 'Enter') {
						e.preventDefault();
						checkPassword();
					}
				});
			}

			// ボタンクリックで認証
			if (submitBtn) {
				submitBtn.addEventListener('click', (e) => {
					e.preventDefault();
					checkPassword();
				});
			}
		},
		externalLink() {
			const links = document.querySelectorAll('.js-cnt-external-link');
			if (!links.length) return;

			const isEnglish = location.pathname.startsWith('/english/');
			const basePath = isEnglish ? '/english/external/' : '/external/';

			links.forEach(link => {
				const name = link.getAttribute('data-name') || '';
				const text = link.getAttribute('data-text') || '';
				const url = link.getAttribute('data-url') || '';

				if (!url) return;

				const params = new URLSearchParams();
				if (name) params.set('name', name);
				if (text) params.set('text', text);
				params.set('url', url);

				link.href = basePath + '?' + params.toString();
				link.setAttribute('target', '_blank');
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.checkAppliParam();
			_this.accordion();
			_this.spAccordion();
			_this.accBtn();
			_this.tabSwitch();
			_this.scrollToActiveTabLink(); // リンク型タブのスクロール
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.popup();
			_this.setModal();
			_this.matchHeight();
			_this.heightSync();
			_this.inViewAnimation();
			_this.inViewAnimationHeadImg()
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.hideEmptyElements();
			_this.removeEmptyLinks();
			_this.URLcurrent();
			_this.pcHeaderMegamenu();
			_this.spHeaderHamburger();
			_this.removeTargetFade();
			_this.currentSet();
			_this.bnrCarousel();
			_this.storySlider();
			_this.cardSlider();
			_this.largeCardeSlider();
			_this.addLinkClass();
			_this.addTableClass();
			_this.initScrollHint();
			_this.regNumber();
			_this.searchModal();
			_this.externalLink();
		let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => {
					_this.matchHeight();
					_this.heightSync();
				}, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
